(() => {
  const resize = () => document.querySelectorAll('.wb-campaign').forEach(hero => {
    const top = hero.getBoundingClientRect().top + window.scrollY;
    hero.style.setProperty('--wb-hero-height', `${Math.max(280,Math.min(800,window.innerHeight-top-24-(document.getElementById('PBarNextFrame') ? 64 : 0)))}px`);
  });
  resize(); window.addEventListener('resize', resize, {passive:true});
  document.fonts.ready.then(resize);
  window.addEventListener('load', () => { resize(); setTimeout(resize, 1000); }, {once:true});
  document.addEventListener('shopify:section:load', resize);
  const header = document.querySelector('#header-group');
  if (header) new ResizeObserver(resize).observe(header);
})();
